<template>
  <div>
    <div class="flexbox-container">
      <div>

        <Head title="Crear cliente" />
        <h1 class="mb-8 text-3xl font-bold">
          <Link class="text-sky-400 hover:text-sky-600" href="/clients">Clientes</Link>
          <span class="text-sky-400 font-medium">/</span> Crear Cliente
        </h1>
      </div>

      <div>
        <div class="form-group">
          <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <h1 class="text-3xl font-bold my-2 w-full">Datos generales</h1>

                <text-input v-model="form.description" :error="form.errors.description"
                  class="pb-8 pr-6 w-full lg:w-1/3" label="Nombre de la tienda" />

                <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/3"
                  label="Categoría">
                  <option disabled value="">Selecciona una opción</option>
                  <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.description
                    }}</option>
                </select-input>
                <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/3"
                  label="Tipo">
                  <option disabled value="">Selecciona una opción</option>
                  <option v-for="type in types" :key="type.id" :value="type.id">{{ type.description }}</option>
                </select-input>

                <text-input v-model="form.comments" :error="form.errors.comments" class="pb-8 pr-6 w-full  lg:w-2/3"
                  label="Comentarios" />

                <h1 class="text-3xl font-bold my-2 w-full">Precios y descuentos</h1>
                <br />
                <div class="pb-8 pr-6 w-full lg:w-2/4">
                  <label class="block">
                    <span class="block text-base text-slate-500">Lista de precios:</span>
                    <Multiselect v-model="form.list_prices" placeholder="Seleciona una opción"
                      :options="prices.map(price => ({ value: price.id, label: price.description }))" mode="tags"
                      :close-on-select="true" :searchable="true" />

                  </label>
                </div>

                <div class="pb-8 pr-6 w-full lg:w-2/4">
                  <label class="block">
                    <span class="block text-base text-slate-500">Lista de descuentos:</span>
                    <!-- {{ form.discount }} -->
                    <Multiselect v-model="form.discount" placeholder="Seleciona una o varias opciones"
                      :options="discounts.map(discount => ({ value: discount.id, label: discount.name }))" mode="tags"
                      :close-on-select="false" :searchable="true" />
                  </label>
                </div>

                <!-- <text-input v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-1/3" type="number" label="Descuento" /> -->

                <h1 class="text-3xl font-bold my-2 w-full">Dirección y contacto</h1>
                <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/3"
                  label="Dirección" />
                <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/3" label="Municipio" />
                <text-input v-model="form.cologne" :error="form.errors.cologne" class="pb-8 pr-6 w-full lg:w-1/3" label="Colonia" />
                <text-input v-model="form.zip_code" :error="form.errors.zip_code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código postal" /> -->
                <text-input v-model="form.in_charge" :error="form.errors.in_charge" class="pb-8 pr-6 w-full lg:w-1/3"
                  label="Encargado" />
                <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3"
                  label="Email" />
                <text-input v-model="form.phone" :error="form.errors.phone" @input="handlePhoneInput" maxlength="10"
                  class="pb-8 pr-6 w-full lg:w-1/3" type="number" label="Teléfono" />
                <text-input-upper v-model="form.rfc" :error="form.errors.rfc" class="pb-8 pr-6 w-full lg:w-1/3"
                  label="RFC" />
                <text-input :model-value="form.lat.toString()" :error="form.errors.lat"
                  class="pb-8 pr-6 w-full lg:w-1/3" label="*Latitud" readonly />
                <text-input :model-value="form.long.toString()" :error="form.errors.long"
                  class="pb-8 pr-6 w-full lg:w-1/3" label="*Longitud" readonly />

              </div>
              <ul role="list" class="marker:text-sky-400 list-disc pl-5 ml-8 space-y-12 text-slate-500 mb-2">
                <li>Para generar las coordenas, busque su dirección o arrastre el marcador en el mapa</li>
              </ul>
              <div>
                <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
                  <div class="flex pt-8 px-8">
                    <text-input v-model="addressInput" class="border border-gray-300 px-3 py-4 w-full rounded-md"
                      placeholder="Ingresa una dirección" label="Geolozalización" />
                    <button class="btn-sky mx-5 my-6" @click.prevent="searchAddress">Buscar</button>
                  </div>
                  <div role="list" class=" list-disc pl-9 space-y-1 text-slate-500 my-4">
                    <p style="color: #7E8A94;">Ejemplo: C. Cam. de la Toma 108, Fraile, 68270 Tlalixtac de Cabrera, Oax.
                    </p>
                  </div>
                </div>
                <GMapMap :center="center" :zoom="zoom" map-type-id="terrain" style="width: 100%; height: 500px"
                  @click="handleClick">
                  <GMapMarker :key="'user-marker'" :position="userPosition" :clickable="true" :draggable="false"
                    @click="center = m.position" />
                </GMapMap>
              </div>
              <div class="flex items-center justify-center px-4 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button id="submitBtn" :loading="form.processing" class="btn-sky" type="submit">Crear
                  Cliente</loading-button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextInputUpper from '@/Shared/TextInputUpper'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextInputUpper,
    Icon,
    Multiselect,
  },
  layout: Layout,
  props: {
    categories: Object,
    prices: Object,
    types: Object,
    discounts: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        description: '',
        category: '',
        type: '',
        comments: 'Sin comentarios', // Valor por defecto
        list_prices: [],
        discount: [],
        address: '',
        // city: '',
        // cologne: '',
        // zip_code: '',
        in_charge: '',
        email: '',
        phone: '',
        rfc: '',
        lat: 0.0,
        long: 0.0,
      }),
      center: { lat: 17.067068284470416, lng: -96.71967474789123 },
      zoom: 10,
      userPosition: { lat: 17.067068284470416, lng: -96.71967474789123 },
      addressInput: '',
      value: null,

    }
  },
  watch: {
    'form.list_prices': function (newVal, oldVal) {
      console.log('List Prices (nuevo valor):', newVal)
    },
    'form.lat': function (newLat, oldLat) {
      console.log('Nueva latitud:', newLat)
    },
    'form.long': function (newLong, oldLong) {
      console.log('Nueva longitud:', newLong)
    },
    form: {
      deep: true,
      handler(newForm, oldForm) {
        this.addressInput = `${this.form.address} `;
      }
    }
  },
  mounted() {
    // Espera a que el DOM esté completamente cargado
    this.$nextTick(() => {
      // Mover el botón "Crear Cliente" dentro del formulario
      const form = document.getElementById('clienteForm')
      const button = document.querySelector('.bg-gray-50.border-t.border-gray-100 .btn-sky .btn-sky')
      if (form && button) {
        form.appendChild(button)
      }
    })
  },
  remember: 'form',
  methods: {
    store() {
      // Asegura que el campo comments tenga un valor predeterminado si está vacío
      const comments = this.form.comments || 'Sin comentarios';

      // Crea un objeto formData con los datos del formulario
      const formData = {
        code: this.form.code,
        description: this.form.description,
        lat: this.form.lat,
        long: this.form.long,


      }

      // Imprime los datos del formulario en la consola
      console.log('Datos completos del formulario que se enviarán al controlador:', formData)

      // Envía los datos del formulario al controlador utilizando el método POST
      this.form.post('/clients', formData)
        .then(() => {
          console.log('Datos del formulario enviado con éxito.')
        })
        .catch((error) => {
          console.error('Error al enviar los datos del formulario:', error)
        })
    },



    searchAddress() {
      // Método para buscar la dirección en el mapa
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: this.addressInput }, (results, status) => {
        if (status === 'OK' && results && results.length) {
          const { lat, lng } = results[0].geometry.location
          this.userPosition = { lat: lat(), lng: lng() }
          this.center = { lat: lat(), lng: lng() }
          this.form.lat = lat()
          this.form.long = lng()

          // Ajustar el zoom del mapa para que enfoque la nueva posición
          this.zoom = 15 // Puedes ajustar el valor del zoom según lo desees
        } else {
          console.error('Error al buscar la dirección:', status)
        }
      })
    },
    handleClick(event) {
      // Método para manejar el clic en el marcador
      const lat = event.latLng.lat()
      const lng = event.latLng.lng()

      this.userPosition = { lat: lat, lng: lng }
      this.form.lat = lat
      this.form.long = lng

      console.log('Coordenadas registradas por el evento de clic - Latitud:', this.form.lat, ' Longitud:', this.form.long)
    },
    handlePhoneInput(event) {
      // Remove any non-numeric characters
      const inputValue = event.target.value.replace(/\D/g, '');

      // Limit the input to 10 digits
      if (inputValue.length > 10) {
        event.target.value = inputValue.slice(0, 10);
      }

      // Update the v-model value
      this.form.phone = inputValue;
    },
  },
}



/*handleClick(event) {
  // Método para manejar el clic en el marcador
  const lat = Number(event.latLng.lat()).toString();
  const lng = Number(event.latLng.lng()).toString();

  this.userPosition = { lat: lat, lng: lng };
  this.form.lat = lat;
  this.form.long = lng;

  console.log('Coordenadas registradas por el evento de clic - Latitud:', this.form.lat, ' Longitud:', this.form.long);
},

//js?key=AIzaSyDQitbi4RV9vRM-Oh1MyDi5-jDnNlIqLNY&libraries=visualization&v=3.47&callback=vueGoogleMapsInit:143 InvalidValueError: setPosition: not a LatLng or LatLngLiteral: in property lat: not a number*/
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
